export type ShellSearchActivityKey =
  | "manual_time_entry"
  | "disputes_queue"
  | "employee_management"
  | "timesheet_review"
  | "none";

export type ShellSearchContext = {
  activityKey: ShellSearchActivityKey;
  enabled: boolean;
  label: string;
  placeholder: string;
  emptyMessage: string;
};

export function resolveShellSearchContext(pathname: string): ShellSearchContext {
  if (pathname.includes("/payroll/timesheets/manual-entry")) {
    return {
      activityKey: "manual_time_entry",
      enabled: true,
      label: "Add time for employee",
      placeholder: "Search employee to add time",
      emptyMessage: "No matching employees found for manual time entry.",
    };
  }

  if (pathname.includes("/payroll/timesheets/disputes")) {
    return {
      activityKey: "disputes_queue",
      enabled: true,
      label: "Filter disputes by employee",
      placeholder: "Search employee with dispute",
      emptyMessage: "No matching employees found for dispute filtering.",
    };
  }

  if (pathname.endsWith("/employees")) {
    return {
      activityKey: "employee_management",
      enabled: true,
      label: "Find employee record",
      placeholder: "Search employee record",
      emptyMessage: "No matching employee records found.",
    };
  }

  if (pathname.endsWith("/payroll/preflight")) {
    return {
      activityKey: "timesheet_review",
      enabled: true,
      label: "Find employee preflight",
      placeholder: "Search employee in preflight",
      emptyMessage:
        "No matching employees found for preflight review.",
    };
  }

  if (pathname.endsWith("/payroll/submit")) {
    return {
      activityKey: "timesheet_review",
      enabled: true,
      label: "Find employee for payroll submit",
      placeholder: "Search employee before submit",
      emptyMessage:
        "No matching employees found for payroll submission.",
    };
  }

  if (
    pathname.endsWith("/payroll/timesheets") ||
    pathname.includes("/payroll/timesheets/review/")
  ) {
    return {
      activityKey: "timesheet_review",
      enabled: true,
      label: "Find employee timesheet",
      placeholder: "Search employee timesheet",
      emptyMessage: "No matching employees found for timesheet review.",
    };
  }

  return {
    activityKey: "none",
    enabled: false,
    label: "Employee search",
    placeholder: "Search employee",
    emptyMessage: "No matching employees found.",
  };
}